import {
  FULL_MARITAL_STATUS_OPTIONS,
  NATIONALITY_OPTIONS,
  OCCUPATION_CATEGORY_OPTIONS
} from "../../constants/dropdownOptions"

export const fields = {
  birthdate: {
    type: "birthdate",
    name: "birthdate",
    label: "data de nascimento",
    sendFormat: "date",
    fetchFormat: "date",
    rules: {
      minAge: 18,
      checkMaxAge: 80.5
    }
  },
  nationality: {
    type: "select",
    name: "nationality",
    label: "nacionalidade",
    placeholder: "selecione",
    options: NATIONALITY_OPTIONS,
    sendFormat: "select",
    fetchFormat: "select",
    defaultValue: "BRASILEIRA"
  },
  occupation_category: {
    type: "select",
    name: "occupation_category",
    label: "tipo de renda",
    placeholder: "selecione",
    options: OCCUPATION_CATEGORY_OPTIONS,
    sendFormat: "select",
    fetchFormat: "select"
  },
  cnpj: {
    type: "cnpj",
    name: "cnpj",
    label: "cnpj",
    sendFormat: "cnpj",
    fetchFormat: "cnpj"
  },
  monthly_income: {
    type: "currency",
    name: "monthly_income",
    label: "renda total mensal",
    rules: {
      greaterThanZero: true
    }
  },
  marital_status: {
    type: "select",
    name: "marital_status",
    label: "estado civil",
    placeholder: "selecione",
    options: FULL_MARITAL_STATUS_OPTIONS,
    sendFormat: "select",
    fetchFormat: "select"
  },
  stable_union: {
    type: "radio",
    name: "stable_union",
    options: [
      {
        id: "stable_union_no",
        value: "nao",
        label: "não",
        ariaLabel: "não convivo em união estável"
      },
      {
        id: "stable_union_yes",
        value: "sim",
        label: "sim",
        ariaLabel: "sim, convivo em união estável"
      }
    ],
    sendFormat: "bool",
    fetchFormat: "bool"
  },
  shareIncome: {
    type: "radio",
    name: "share_income",
    options: [
      {
        id: "share_income_no",
        value: "nao",
        label: "não",
        checked: true,
        ariaLabel: "não desejo somar renda"
      },
      {
        id: "share_income_yes",
        value: "sim",
        label: "sim",
        ariaLabel: "sim, desejo somar renda"
      }
    ],
    sendFormat: "bool",
    fetchFormat: "bool"
  },
  partnerName: {
    type: "name",
    name: "partner_name",
    label: "nome completo",
    sendFormat: "text"
  },
  partnerCpf: {
    type: "cpf",
    name: "partner_cpf",
    label: "CPF",
    sendFormat: "cpf",
    fetchFormat: "cpf",
    rules: {
      distinctDocument: true
    }
  },
  partnerBirthdate: {
    type: "birthdate",
    name: "partner_birthdate",
    label: "data de nascimento",
    sendFormat: "date",
    fetchFormat: "date",
    rules: {
      minAge: 18,
      finacingTermWithAgePartner: 80.5
    }
  },
  partnerNationality: {
    type: "select",
    name: "partner_nationality",
    label: "nacionalidade",
    placeholder: "selecione",
    options: NATIONALITY_OPTIONS,
    sendFormat: "select",
    fetchFormat: "select",
    defaultValue: "BRASILEIRA"
  },
  partnerOccupationCategory: {
    type: "select",
    name: "partner_occupation_category",
    label: "tipo de renda",
    placeholder: "selecione",
    options: OCCUPATION_CATEGORY_OPTIONS,
    sendFormat: "select",
    fetchFormat: "select"
  },
  partnerCnpj: {
    type: "cnpj",
    name: "partner_cnpj",
    label: "cnpj",
    sendFormat: "cnpj",
    fetchFormat: "cnpj"
  },
  partnerMonthlyIncome: {
    type: "currency",
    name: "partner_monthly_income",
    label: "renda total mensal",
    rules: {
      greaterThanZero: true
    }
  },
  partnerMaritalStatus: {
    type: "select",
    name: "partner_marital_status",
    label: "estado civil",
    placeholder: "selecione",
    options: FULL_MARITAL_STATUS_OPTIONS,
    sendFormat: "select",
    fetchFormat: "select"
  },
  partnerSameContact: {
    type: "radio",
    name: "partner_same_contact",
    options: [
      {
        id: "partner_same_contact_no",
        value: "nao",
        label: "não",
        ariaLabel: "não desejo utilizar os mesmos dados de contato que os meus"
      },
      {
        id: "partner_same_contact_yes",
        value: "sim",
        label: "sim",
        checked: true,
        ariaLabel: "sim, desejo utilizar os mesmos dados de contato que os meus"
      }
    ],
    sendFormat: "bool",
    fetchFormat: "bool"
  },
  partnerEmail: {
    type: "email",
    name: "partner_email",
    label: "e-mail",
    rules: {
      differentEmailFromOriginal: true
    }
  },
  partnerPhone1: {
    type: "cellphone",
    name: "partner_phone_1",
    label: "celular",
    sendFormat: "phone",
    fetchFormat: "phone",
    rules: {
      differentTelephoneOriginal: true
    }
  }
}
